import { AppBar, Divider, Drawer, IconButton, InputAdornment, TextField, Toolbar, Typography } from "@material-ui/core";
import React, { PropsWithChildren, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { GridGrow } from "../../../components/GridGrow";
import { UserAvatar } from "../../../components/UserAvatar";
import { useOfflineAssets } from "../../offline/useOfflineAssets";
import { AddNewFab } from "../AddNew/AddNewFab";
import { LibraryView, useLibrary, useLibrarySearch } from "../LibraryPage";
import { SideNavigation } from "../SideBar/SideNavigation";
import SearchIcon from "@material-ui/icons/Search";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { routes } from "../../../routes";

const getMobileTitle = (activeView: LibraryView) => {
	switch (activeView) {
		case LibraryView.Calendar:
			return "Calendar";
		case LibraryView.Search:
			return "Search Results";
		case LibraryView.Starred:
			return "Starred";
		case LibraryView.Recent:
			return "Recent";
		case LibraryView.SermonTemplateList:
			return "Sermon Templates";
		case LibraryView.PremiumSermonDetail:
		case LibraryView.PremiumSermonList:
			return "Premium Sermons";
		case LibraryView.PremiumSermonSeriesDetail:
		case LibraryView.PremiumSermonSeriesList:
			return "Premium Series";
		default:
			return "My Library";
	}
};

export function MobileLibraryLayout(props: PropsWithChildren<{}>) {
	const history = useHistory();
	const context = useLibrary();
	const { activeView } = context;
	const searchContext = useLibrarySearch();
	const { onlineMode } = useOfflineAssets();

	const [showNavDrawer, setShowNavDrawer] = useState(false);
	const [showSearchField, setShowSearchField] = useState<boolean>(searchContext.searchValue !== "");

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useMemo(() => setShowNavDrawer(false), [activeView])
	const showBackButton = useMemo(() => context.activeFolderId !== null, [context.activeFolderId]);

	return (
		<div id="library-mobile-layout">
			<div id="library-mobile-layout-header">
				<AppBar position="absolute" style={{ backgroundColor: "#FFF", boxShadow: "none", height: 64 }}>
					<Toolbar>
						{showSearchField ? (
							<>
								<IconButton
									onClick={() => {
										history.goBack();
										setShowSearchField(false);
									}}
								>
									<ArrowBackIcon />
								</IconButton>
								<TextField
									id="search-input-mobile"
									placeholder="Search"
									fullWidth
									variant="outlined"
									autoFocus
									value={searchContext.searchValue}
									onChange={(e) => searchContext.setSearchValue(e.target.value)}
									style={{ paddingTop: 2, paddingRight: 3}}
									inputProps={{ style: { padding: 14 } }}
									InputProps={{
										endAdornment:(
											<InputAdornment position="end">
												<SearchIcon style={{ color: "rgba(0,0,0,0.54)" }} />
											</InputAdornment>
										),
									}}
								/>
								<UserAvatar />
							</>
						) : (
							<>
								<IconButton
									color="inherit"
									aria-label="  "
									onClick={() => (showBackButton ? history.goBack() : setShowNavDrawer((show) => !show))}
									style={{ color: "rgba(0,0,0,0.54)" }}
									disabled={!onlineMode}
								>
									{showBackButton ? <ArrowBackIcon /> : <MenuIcon />}
								</IconButton>
								<Typography
									variant="h2"
									gutterBottom
									style={{
										fontWeight: 500,
										color: "rgba(0,0,0,0.54)",
										fontSize: 20,
										margin: 8,
									}}
								>
									{getMobileTitle(activeView)}
								</Typography>
								<GridGrow />
								<IconButton onClick={() => setShowSearchField(true)} disabled={!onlineMode} style={{marginRight: 4}}>
									<SearchIcon />
								</IconButton>
								<UserAvatar />
							</>
						)}
					</Toolbar>
				</AppBar>
				<Drawer
					variant="temporary"
					anchor={"left"}
					open={showNavDrawer}
					onClose={() => setShowNavDrawer(false)}
					ModalProps={{ keepMounted: true }}
				>
					<Link to={routes.app.libraryHomePage} style={{ textDecoration: "none" }}>
						<img
							style={{ display: "block", width: "100%", maxWidth: 250, padding: 20 }}
							src="//i.cdn-sc.com/Logos/sm-horiz300.png"
							alt="Sermon Maker"
						/>
					</Link>
					<Divider />
					<SideNavigation />
				</Drawer>
			</div>
			<div
				id="library-mobile-layout-header-view"
				style={{
					position: "absolute",
					top: 64,
					left: 0,
					right: 0,
					bottom: 0,
					overflowY: "auto",
				}}
			>
				{props.children}
			</div>
			<AddNewFab />
		</div>
	);
}
